export default "__VITE_ASSET__7934ae75__"